module.exports = __webpack_public_path__ + "img/WechatIMG5c7d0622180e6203b2d34c5e8408e23d.ac122fd5.png";